import FirmwareCategoryTypes from 'store/actionTypes/firmwareCategory'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  system: []
}

const FirmwareCategory = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case FirmwareCategoryTypes.GET_SYSTEM_FIRMWARE_CATEGORIES_SUCCESS:
      return {
        ...state,
        system: payload?.items || []
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default FirmwareCategory
